import script from "./OnboardingAiGradientProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiGradientProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiGradientProgressBar.vue?vue&type=style&index=0&id=53f41636&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f41636"]])

export default __exports__